var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuCompletedOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.916 9.404l-1.308-1.317A.284.284 0 0020.4 8a.272.272 0 00-.208.087l-9.065 8.944-3.3-3.231a.297.297 0 00-.207-.087.297.297 0 00-.208.087l-1.323 1.295a.286.286 0 000 .415l4.161 4.075c.268.262.595.415.87.415.393 0 .735-.284.861-.4h.008l9.934-9.78c.104-.124.104-.306-.007-.416z"
  })));
}
export default SvgMenuCompletedOutline;